{
  "v5.m1.annuler": "Annuler",
  "v5.m1.branches.par_defaut": "par défaut",
  "v5.m1.branches.titre": "Branches",
  "v5.m1.branches.vide": "Aucune branche dans le dépôt.",
  "v5.m1.branches.voir_pipelines": "Pipelines de {{branche}}",
  "v5.m1.cas.afficher_test": "Afficher le test exécutable",
  "v5.m1.cas.ajoute": "Cas ajouté à la suite.",
  "v5.m1.cas.ajouter_suite": "Ajouter à la suite de non-régression",
  "v5.m1.cas.attendu": "attendu : {{attendu}}",
  "v5.m1.cas.aucune_campagne": "Aucune campagne ouverte dans ce projet.",
  "v5.m1.cas.campagne": "Campagne d’exécution",
  "v5.m1.cas.campagne_option": "{{nom}} (#{{id}})",
  "v5.m1.cas.campagne_requise": "Choisissez une campagne ouverte pour exécuter ce cas.",
  "v5.m1.cas.campagnes": "Campagnes ouvertes",
  "v5.m1.cas.choisir_campagne": "Choisir une campagne",
  "v5.m1.cas.cibles": "Cibles prouvées",
  "v5.m1.cas.contenu_non_fige": "Le contenu du cas n’est pas figé à la publication : seuls la version et la position le sont.",
  "v5.m1.cas.criticite": "Criticité",
  "v5.m1.cas.declarer_anomalie": "Déclarer une anomalie depuis ce résultat",
  "v5.m1.cas.deja_inclus": "Ce cas est déjà dans la suite de non-régression.",
  "v5.m1.cas.echec_ajout": "Le cas n’a pas été ajouté.",
  "v5.m1.cas.ecrire_test": "Écrire le test",
  "v5.m1.cas.etat_test.a_valider": "À valider",
  "v5.m1.cas.etat_test.absent": "Absent",
  "v5.m1.cas.etat_test.valide": "Validé",
  "v5.m1.cas.executer": "Exécuter ce cas",
  "v5.m1.cas.executer_campagne": "Exécuter dans la campagne",
  "v5.m1.cas.historique": "Historique",
  "v5.m1.cas.identite": "Identité",
  "v5.m1.cas.introuvable": "Cas de test introuvable dans ce projet.",
  "v5.m1.cas.libelle": "Cas de test",
  "v5.m1.cas.masquer_test": "Masquer le test exécutable",
  "v5.m1.cas.modifier_identite": "Modifier l’identité",
  "v5.m1.cas.modifier_scenario": "Modifier le scénario",
  "v5.m1.cas.niveau.critical": "Critique",
  "v5.m1.cas.niveau.high": "Haute",
  "v5.m1.cas.niveau.low": "Faible",
  "v5.m1.cas.niveau.medium": "Moyenne",
  "v5.m1.cas.nom": "Nom",
  "v5.m1.cas.origine.element_du_cas": "élément du cas",
  "v5.m1.cas.origine.trace_declaree": "trace déclarée",
  "v5.m1.cas.origine_execution": "Exécution d’origine",
  "v5.m1.cas.preparer_validation": "Préparer la validation",
  "v5.m1.cas.priorite": "Priorité",
  "v5.m1.cas.reference": "Référence",
  "v5.m1.cas.resultat": "Résultat de l’exécution #{{id}}",
  "v5.m1.cas.resultat_attendu": "Résultat attendu",
  "v5.m1.cas.retirer_suite": "Retirer de la suite",
  "v5.m1.cas.retour_tests": "Retour aux tests",
  "v5.m1.cas.sans_cible": "Aucune cible prouvée.",
  "v5.m1.cas.sans_etape": "Aucune étape.",
  "v5.m1.cas.sans_execution_origine": "Aucune exécution d’origine : ouvrez ce cas depuis un résultat pour déclarer une anomalie.",
  "v5.m1.cas.sans_version": "Aucune version publiée ne contient ce cas.",
  "v5.m1.cas.scenario": "Scénario",
  "v5.m1.cas.suite": "Suite de non-régression",
  "v5.m1.cas.test_absent": "Aucun test exécutable.",
  "v5.m1.cas.test_executable": "Test exécutable",
  "v5.m1.cas.titre": "Cas de test",
  "v5.m1.cas.version": "Plan {{plan}} · version {{version}} · publiée par {{auteur}}",
  "v5.m1.cas.voir_anomalie": "Voir l’anomalie",
  "v5.m1.code.ATTESTATION_RELECTURE_REQUISE": "Attestez avoir relu le test avant de le valider.",
  "v5.m1.code.CONTEXTE_INCOMPLET": "Le contexte du geste est incomplet.",
  "v5.m1.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v5.m1.code.GARDE_DROIT_ABSENTE": "Ce geste n’est pas encore ouvert par la passerelle.",
  "v5.m1.code.RESOURCE_UNAVAILABLE": "Traitement introuvable dans ce projet.",
  "v5.m1.code.RETOUR_INTROUVABLE": "Ce retour est introuvable dans ce projet.",
  "v5.m1.code.REVISION_NOT_DONE": "Cette révision n’est pas aboutie : elle ne peut pas être publiée.",
  "v5.m1.code.REVISION_NOT_FOUND": "Révision introuvable dans ce projet.",
  "v5.m1.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v5.m1.code.SCM_NOT_CONFIGURED": "Aucun dépôt n’est raccordé à ce projet.",
  "v5.m1.code.SCM_NOT_FOUND": "Objet introuvable dans le dépôt raccordé.",
  "v5.m1.code.TEST_CODE_VALIDATOR_NOT_INDEPENDENT": "Le test doit être validé par une autre personne que son auteur.",
  "v5.m1.code.VALIDATION_ERROR": "La demande est incomplète ou invalide.",
  "v5.m1.code.VALIDATION_PAR_UN_TIERS": "Ce geste doit être fait par une autre personne que l’auteur.",
  "v5.m1.code.WAIVER_ALREADY_ACTIVE": "Un écart est déjà actif pour cette vulnérabilité.",
  "v5.m1.code.WAIVER_EXPIRY_REQUIRED": "L’échéance de l’écart est requise.",
  "v5.m1.code.WAIVER_SELF_APPROVAL_REFUSED": "L’écart doit être validé par une autre personne que celle qui l’a demandé.",
  "v5.m1.code.ecart.VALIDATION_ERROR": "Demande d’écart refusée : {{message}}",
  "v5.m1.code.ecart.VALIDATION_PAR_UN_TIERS": "L’écart doit être validé par une autre personne que celle qui l’a demandé.",
  "v5.m1.code.ecart.WAIVER_EXPIRY_REQUIRED": "L’échéance doit être dans le futur.",
  "v5.m1.code.ecart.WAIVER_PIPELINE_VALIDITY_EXCEEDED": "Un écart sur le contrôle du pipeline vaut {{max_days}} jours au plus : la dernière échéance acceptable est le {{latest_date}}.",
  "v5.m1.code.ecart.WAIVER_SECURITY_REVIEW_REQUIRED": "Au-delà de 90 jours, un écart de sécurité exige une revue de sécurité consignée : choisissez une échéance plus proche.",
  "v5.m1.code.publier.VALIDATION_PAR_UN_TIERS": "La révision doit être relue par une autre personne que celle qui la publie.",
  "v5.m1.code.test.VALIDATION_PAR_UN_TIERS": "Le test doit être validé par une autre personne que son auteur.",
  "v5.m1.declencher.branche": "Branche",
  "v5.m1.declencher.branche_requise": "Choisissez une branche.",
  "v5.m1.declencher.branches": "Branches du dépôt",
  "v5.m1.declencher.choisir_branche": "Choisir une branche",
  "v5.m1.declencher.consommation": "Le pipeline consomme du temps de runner du dépôt.",
  "v5.m1.declencher.declenche": "Pipeline déclenché.",
  "v5.m1.declencher.declencher": "Déclencher",
  "v5.m1.declencher.echec": "Le déclenchement a échoué.",
  "v5.m1.declencher.effet": "Un pipeline sera lancé sur la branche « {{branche}} » du dépôt {{depot}} ({{url}}).",
  "v5.m1.declencher.effet_sans_branche": "Choisissez la branche sur laquelle lancer le pipeline.",
  "v5.m1.declencher.raison_depot": "Raccordez un dépôt au projet pour déclencher un pipeline.",
  "v5.m1.declencher.source": "Source conservée : application {{application}}, révision {{revision}}.",
  "v5.m1.declencher.titre": "Déclencher un pipeline du dépôt",
  "v5.m1.depot.connecte": "Dépôt raccordé : projet {{depot}} sur {{url}}.",
  "v5.m1.depot.connexion": "Connexion du dépôt",
  "v5.m1.depot.echec_test": "Le test de connexion a échoué.",
  "v5.m1.depot.non_connecte": "Aucun dépôt n’est raccordé à ce projet.",
  "v5.m1.depot.reglages": "Réglages du dépôt",
  "v5.m1.depot.teste": "Connexion vérifiée : {{chemin}}.",
  "v5.m1.depot.tester": "Tester la connexion",
  "v5.m1.depot.titre": "Dépôt du projet",
  "v5.m1.ecarter.composant": "Composant",
  "v5.m1.ecarter.contexte_requis": "Ouvrez ce dialogue depuis une vulnérabilité d’un pipeline.",
  "v5.m1.ecarter.echeance": "Échéance",
  "v5.m1.ecarter.echeance_aide": "{{jours}} jours au plus (contrôle du pipeline) : jusqu’au {{date}} inclus.",
  "v5.m1.ecarter.echeance_borne": "L’échéance doit être comprise entre demain et le {{date}}.",
  "v5.m1.ecarter.echeance_requise": "L’échéance est requise.",
  "v5.m1.ecarter.echec": "L’écart n’a pas été soumis.",
  "v5.m1.ecarter.gravite": "Gravité",
  "v5.m1.ecarter.identifiant": "Identifiant",
  "v5.m1.ecarter.justification": "Justification",
  "v5.m1.ecarter.motif_requis": "Le motif est requis.",
  "v5.m1.ecarter.nature": "Nature du motif",
  "v5.m1.ecarter.nature.non_affecte_justifie": "Non affecté, justifié",
  "v5.m1.ecarter.nature.risque_accepte": "Risque accepté",
  "v5.m1.ecarter.soumettre": "Soumettre l’écart",
  "v5.m1.ecarter.soumis": "Écart soumis.",
  "v5.m1.ecarter.soumission_impossible_inconnue": "Soumission impossible : la vulnérabilité n’est pas relevée par l’analyse de ce pipeline.",
  "v5.m1.ecarter.tiers": "L’écart n’aura d’effet qu’après sa validation par une autre personne.",
  "v5.m1.ecarter.titre": "Écarter une vulnérabilité avec motif",
  "v5.m1.ecarter.vulnerabilite": "Vulnérabilité",
  "v5.m1.ecarter.vulnerabilite_inconnue": "Cette vulnérabilité n’est pas relevée dans le pipeline.",
  "v5.m1.ecran_non_realise": "« {{ecran}} » : cet écran arrive avec un autre lot de la version ; il n’est pas encore ouvert.",
  "v5.m1.etat.chargement": "Chargement : {{quoi}}…",
  "v5.m1.etat.en_cours": "En cours…",
  "v5.m1.etat.erreur": "{{quoi}} : la lecture a échoué.",
  "v5.m1.etat.introuvable": "{{quoi}} introuvable dans ce projet.",
  "v5.m1.etat.reessayer": "Réessayer",
  "v5.m1.etat.refus": "{{quoi}} : accès refusé.",
  "v5.m1.execution.aucun_resultat": "Aucun résultat d’étape enregistré.",
  "v5.m1.execution.choisir_etape": "Choisissez une étape pour voir son résultat.",
  "v5.m1.execution.code": "Code de retour : {{code}}",
  "v5.m1.execution.debut": "Début",
  "v5.m1.execution.duree": "Durée : {{duree}} s",
  "v5.m1.execution.duree_inconnue": "Durée inconnue",
  "v5.m1.execution.etape.echoue": "Échec",
  "v5.m1.execution.etape.non_execute": "Non exécutée",
  "v5.m1.execution.etape.reussi": "Réussie",
  "v5.m1.execution.etat": "État",
  "v5.m1.execution.etat.echoue": "Échouée",
  "v5.m1.execution.etat.en_attente": "En attente",
  "v5.m1.execution.etat.non_execute": "Non exécutée",
  "v5.m1.execution.etat.termine": "Terminée",
  "v5.m1.execution.fin": "Fin",
  "v5.m1.execution.introuvable": "Exécution introuvable.",
  "v5.m1.execution.lanceur": "Lancée par",
  "v5.m1.execution.libelle": "Exécution",
  "v5.m1.execution.numero": "Exécution #{{id}}",
  "v5.m1.execution.par_etape": "Résultat par étape",
  "v5.m1.execution.resultat": "Résultat de {{etape}}",
  "v5.m1.execution.sortie_absente": "Aucune sortie conservée pour cette étape.",
  "v5.m1.execution.titre": "Exécution d’une suite de commandes",
  "v5.m1.execution.voir": "Voir le résultat de {{etape}}",
  "v5.m1.execution.voir_suite": "Voir la suite de commandes",
  "v5.m1.fermer": "Fermer",
  "v5.m1.fiche_pub.aucun_environnement": "Aucun environnement relié au dépôt de l’application.",
  "v5.m1.fiche_pub.choisir_environnement": "Choisir un environnement",
  "v5.m1.fiche_pub.commit": "Commit",
  "v5.m1.fiche_pub.date": "Date",
  "v5.m1.fiche_pub.demandee_par": "Demandée par",
  "v5.m1.fiche_pub.dernier_refus": "Dernier refus : {{message}}",
  "v5.m1.fiche_pub.echec_relier": "Le raccordement a échoué.",
  "v5.m1.fiche_pub.effet_raccordement": "La révision {{revision}} sera reliée à l’environnement {{environnement}} ; le service peut en être affecté.",
  "v5.m1.fiche_pub.effet_sans_environnement": "Choisissez un environnement : le raccordement exige le droit de déployer.",
  "v5.m1.fiche_pub.environnement": "Environnement",
  "v5.m1.fiche_pub.environnement_non_identifie": "Aucun environnement choisi.",
  "v5.m1.fiche_pub.environnements": "Environnements",
  "v5.m1.fiche_pub.erreur": "Erreur",
  "v5.m1.fiche_pub.etat": "État",
  "v5.m1.fiche_pub.libelle": "Publication",
  "v5.m1.fiche_pub.pipeline": "Pipeline #{{id}}",
  "v5.m1.fiche_pub.publication": "Publication",
  "v5.m1.fiche_pub.raccordement": "Raccordement à un environnement",
  "v5.m1.fiche_pub.relais": "Trouver un responsable des mises en production",
  "v5.m1.fiche_pub.relancee": "Publication relancée.",
  "v5.m1.fiche_pub.relancer": "Relancer la publication",
  "v5.m1.fiche_pub.relancer_consequence": "La même révision est publiée à nouveau sur la même ligne.",
  "v5.m1.fiche_pub.relancer_titre": "Relancer la publication de {{revision}} ?",
  "v5.m1.fiche_pub.relancer_verbe": "Relancer",
  "v5.m1.fiche_pub.relie": "Environnement relié.",
  "v5.m1.fiche_pub.relier": "Relier l’environnement",
  "v5.m1.fiche_pub.relier_consequence": "L’environnement prendra le dépôt de l’application pour source.",
  "v5.m1.fiche_pub.relier_titre": "Relier l’environnement {{environnement}} ?",
  "v5.m1.fiche_pub.relier_verbe": "Relier",
  "v5.m1.fiche_pub.sans_pipeline": "Aucun pipeline identifié.",
  "v5.m1.fiche_pub.titre": "Détail d’une publication de code",
  "v5.m1.fiche_pub.voir_environnement": "Voir l’environnement {{nom}}",
  "v5.m1.fusion.branche_cible": "Branche cible",
  "v5.m1.fusion.branche_par_defaut": "Branche par défaut du dépôt",
  "v5.m1.fusion.branche_source": "Branche source",
  "v5.m1.fusion.construit_serveur": "Construits par le serveur depuis l’élément",
  "v5.m1.fusion.creation": "La proposition est construite par le serveur à partir d’un élément du projet.",
  "v5.m1.fusion.creee": "Proposition de fusion créée.",
  "v5.m1.fusion.creer": "Créer la proposition de fusion",
  "v5.m1.fusion.echec": "La proposition n’a pas été créée.",
  "v5.m1.fusion.element": "Élément #{{id}}",
  "v5.m1.fusion.element_requis": "Indiquez l’élément du projet à proposer.",
  "v5.m1.fusion.etat.fermee": "Fermée",
  "v5.m1.fusion.etat.fusionnee": "Fusionnée",
  "v5.m1.fusion.etat.ouverte": "Ouverte",
  "v5.m1.fusion.libelle": "Proposition de fusion",
  "v5.m1.fusion.provenance": "Provenance",
  "v5.m1.fusion.provenance_observee": "Branche {{branche}}, commit {{commit}}",
  "v5.m1.fusion.sans_provenance": "Aucune provenance observée.",
  "v5.m1.fusion.selecteur": "Élément du projet (numéro)",
  "v5.m1.fusion.titre": "Branche et proposition de fusion",
  "v5.m1.fusion.titre_creation": "Proposer une fusion",
  "v5.m1.fusion.titre_description": "Titre et description",
  "v5.m1.fusions.etat_gitlab.closed": "Fermée",
  "v5.m1.fusions.etat_gitlab.locked": "Verrouillée",
  "v5.m1.fusions.etat_gitlab.merged": "Fusionnée",
  "v5.m1.fusions.etat_gitlab.opened": "Ouverte",
  "v5.m1.fusions.lien": "!{{iid}} {{titre}}",
  "v5.m1.fusions.proposer": "Proposer une fusion",
  "v5.m1.fusions.titre": "Propositions de fusion",
  "v5.m1.fusions.vide": "Aucune proposition de fusion.",
  "v5.m1.gitlab.statut.canceled": "Annulé",
  "v5.m1.gitlab.statut.created": "Créé",
  "v5.m1.gitlab.statut.failed": "Échec",
  "v5.m1.gitlab.statut.manual": "Manuel",
  "v5.m1.gitlab.statut.pending": "En attente",
  "v5.m1.gitlab.statut.running": "En cours",
  "v5.m1.gitlab.statut.skipped": "Sauté",
  "v5.m1.gitlab.statut.success": "Succès",
  "v5.m1.journal.aucun_resultat": "Aucun résultat.",
  "v5.m1.journal.cible": "Mission {{mission}} · tâche {{tache}} · étape {{etape}}",
  "v5.m1.journal.cible_absente": "Cible non fournie par le traitement",
  "v5.m1.journal.cible_libelle": "Cible du traitement",
  "v5.m1.journal.col.date": "Date",
  "v5.m1.journal.col.document": "Document",
  "v5.m1.journal.col.statut": "Statut",
  "v5.m1.journal.col.traitement": "Traitement",
  "v5.m1.journal.deposer": "Déposer une entrée",
  "v5.m1.journal.detail": "Détail",
  "v5.m1.journal.etape_ciblee": "Ouvrir l’étape ciblée",
  "v5.m1.journal.etape_indisponible": "La mission, la tâche et l’étape de ce traitement ne sont pas toutes connues.",
  "v5.m1.journal.executant": "Exécutant",
  "v5.m1.journal.executant_disponible": "Exécutant disponible",
  "v5.m1.journal.executant_indisponible": "Exécutant indisponible : {{raison}}",
  "v5.m1.journal.filtre_recu": "Filtré sur : {{cible}}",
  "v5.m1.journal.liste": "Traitements du projet",
  "v5.m1.journal.masquer_detail": "Masquer le détail",
  "v5.m1.journal.ordre": "Ordre",
  "v5.m1.journal.ordre.croissant": "Croissant",
  "v5.m1.journal.ordre.decroissant": "Décroissant",
  "v5.m1.journal.ouvrir_traitement": "Ouvrir le traitement {{id}}",
  "v5.m1.journal.rechercher": "Rechercher",
  "v5.m1.journal.resultats_semantiques": "Résultats de la recherche sémantique",
  "v5.m1.journal.semantique": "Recherche sémantique",
  "v5.m1.journal.statut.done": "Terminé",
  "v5.m1.journal.statut.failed": "Échoué",
  "v5.m1.journal.statut.pending": "En attente",
  "v5.m1.journal.statut.processing": "En cours",
  "v5.m1.journal.statut.worker_lost": "Exécutant perdu",
  "v5.m1.journal.terme_requis": "Saisissez un terme pour lancer la recherche sémantique.",
  "v5.m1.journal.titre": "Journal des traitements",
  "v5.m1.journal.tous": "Tous les traitements",
  "v5.m1.journal.tous_affiches": "Tous les traitements du projet sont affichés.",
  "v5.m1.journal.trier_par": "Trier par",
  "v5.m1.journal.vide": "Aucun traitement dans ce projet.",
  "v5.m1.journal.voir_detail": "Voir le détail",
  "v5.m1.missions.arret_ia": "Arrêt de l’IA",
  "v5.m1.missions.attentes": "Décisions humaines en attente",
  "v5.m1.missions.attentes_vide": "Aucune décision humaine en attente.",
  "v5.m1.missions.aucun_resultat": "Aucune mission pour ce filtre.",
  "v5.m1.missions.col.avancement": "Avancement",
  "v5.m1.missions.col.date": "Créée le",
  "v5.m1.missions.col.etat": "État",
  "v5.m1.missions.col.mission": "Mission",
  "v5.m1.missions.escalades": "{{n}} escalade(s) ouverte(s)",
  "v5.m1.missions.filtre.a_decider": "À décider",
  "v5.m1.missions.filtre.arretees": "Arrêtées",
  "v5.m1.missions.filtre.echouees": "Échouées",
  "v5.m1.missions.filtre.en_cours": "En cours",
  "v5.m1.missions.filtre.reussies": "Réussies",
  "v5.m1.missions.filtre.suspendues": "Suspendues",
  "v5.m1.missions.filtre.toutes": "Toutes",
  "v5.m1.missions.filtre_etat": "État",
  "v5.m1.missions.ia_active": "L’IA est disponible.",
  "v5.m1.missions.ia_interrompue": "L’IA est interrompue : aucune mission ne progresse.",
  "v5.m1.missions.lancer": "Lancer une mission",
  "v5.m1.missions.liste": "Missions du projet",
  "v5.m1.missions.plan_a_approuver": "Plan à approuver",
  "v5.m1.missions.retour_projet": "Retour au projet",
  "v5.m1.missions.statut.draft": "Brouillon",
  "v5.m1.missions.statut.failed": "Échouée",
  "v5.m1.missions.statut.plan_approved": "Plan approuvé",
  "v5.m1.missions.statut.plan_proposed": "Plan proposé",
  "v5.m1.missions.statut.running": "En cours",
  "v5.m1.missions.statut.stopped": "Arrêtée",
  "v5.m1.missions.statut.succeeded": "Réussie",
  "v5.m1.missions.statut.suspended": "Suspendue",
  "v5.m1.missions.supervision": "Supervision des agents",
  "v5.m1.missions.taches": "{{fait}} / {{total}} tâches",
  "v5.m1.missions.titre": "Missions",
  "v5.m1.missions.tri": "Tri",
  "v5.m1.missions.tri.plus_anciens": "Plus anciennes d’abord",
  "v5.m1.missions.tri.plus_recents": "Plus récentes d’abord",
  "v5.m1.missions.vide": "Aucune mission dans ce projet.",
  "v5.m1.partage.actif": "Lien actif",
  "v5.m1.partage.adresse": "Adresse",
  "v5.m1.partage.apercu_arrete": "Aperçu arrêté",
  "v5.m1.partage.auteur": "Créé par",
  "v5.m1.partage.copie": "Lien copié.",
  "v5.m1.partage.copie_impossible": "Copie impossible : sélectionnez l’adresse affichée.",
  "v5.m1.partage.copier": "Copier le lien",
  "v5.m1.partage.echeance": "Échéance",
  "v5.m1.partage.echec_revoquer": "La révocation a échoué.",
  "v5.m1.partage.etat": "État",
  "v5.m1.partage.hors_contexte": "Ce lien ne correspond pas à cet aperçu de ce projet.",
  "v5.m1.partage.introuvable": "Lien de partage introuvable.",
  "v5.m1.partage.libelle": "Lien de partage",
  "v5.m1.partage.lien_de": "Aperçu de {{application}}, révision {{revision}}",
  "v5.m1.partage.ouvrir_apercu": "Ouvrir l’aperçu",
  "v5.m1.partage.retour": "Retour aux aperçus",
  "v5.m1.partage.revoque": "Lien révoqué.",
  "v5.m1.partage.revoque_ou_echu": "Ce lien a été révoqué ou est échu.",
  "v5.m1.partage.revoquer": "Révoquer le lien",
  "v5.m1.partage.revoquer_consequence": "Le lien cesse d’ouvrir l’aperçu pour tous ses destinataires.",
  "v5.m1.partage.revoquer_titre": "Révoquer ce lien de partage ?",
  "v5.m1.partage.revoquer_verbe": "Révoquer",
  "v5.m1.partage.titre": "Lien de partage d’un aperçu",
  "v5.m1.pipeline.analyse_non_raccordee": "Dette et seuils : aucun outil d’analyse raccordé ; portes lues dans les traitements du pipeline.",
  "v5.m1.pipeline.aucun_traitement": "Aucun traitement dans ce pipeline.",
  "v5.m1.pipeline.aucune_porte": "Aucune porte qualité dans ce pipeline.",
  "v5.m1.pipeline.aucune_vulnerabilite": "Aucune vulnérabilité relevée.",
  "v5.m1.pipeline.couverture": "Couverture du nouveau code : {{valeur}} %",
  "v5.m1.pipeline.couverture_inconnue": "Couverture du nouveau code non mesurée.",
  "v5.m1.pipeline.ecart_accorde": "Écart validé",
  "v5.m1.pipeline.ecart_detail": "Motif : {{motif}} · échéance {{echeance}} · demandé par {{auteur}}",
  "v5.m1.pipeline.ecart_valide": "Écart validé.",
  "v5.m1.pipeline.ecarter": "Écarter {{id}}",
  "v5.m1.pipeline.ecarts": "Écarts",
  "v5.m1.pipeline.echec_valider": "La validation de l’écart a échoué.",
  "v5.m1.pipeline.etat.annule": "Annulé",
  "v5.m1.pipeline.etat.echoue": "Échoué",
  "v5.m1.pipeline.etat.en_attente": "En attente",
  "v5.m1.pipeline.etat.en_cours": "En cours",
  "v5.m1.pipeline.etat.reussi": "Réussi",
  "v5.m1.pipeline.introuvable": "Pipeline introuvable.",
  "v5.m1.pipeline.libelle": "Pipeline",
  "v5.m1.pipeline.lien": "Pipeline #{{id}} ({{ref}})",
  "v5.m1.pipeline.porte.echouee": "Échouée",
  "v5.m1.pipeline.porte.en_cours": "En cours",
  "v5.m1.pipeline.porte.non_jouee": "Non jouée",
  "v5.m1.pipeline.porte.passee": "Passée",
  "v5.m1.pipeline.portes": "Portes qualité du code",
  "v5.m1.pipeline.relecture_attente": "Relecture en attente",
  "v5.m1.pipeline.titre": "Détail d’un pipeline du dépôt",
  "v5.m1.pipeline.trace": "Trace du traitement",
  "v5.m1.pipeline.trace_vide": "Trace vide.",
  "v5.m1.pipeline.valider_ecart": "Valider l’écart",
  "v5.m1.pipeline.verdict.aucune_porte": "Aucune porte",
  "v5.m1.pipeline.verdict.echouee": "Échouée",
  "v5.m1.pipeline.verdict.en_cours": "En cours",
  "v5.m1.pipeline.verdict.incomplete": "Incomplète",
  "v5.m1.pipeline.verdict.passee": "Passée",
  "v5.m1.pipeline.voir_trace": "Voir la trace de {{nom}}",
  "v5.m1.pipeline.vulnerabilites": "Vulnérabilités de la révision",
  "v5.m1.pipelines.declencher_lien": "Déclencher un pipeline",
  "v5.m1.pipelines.lien": "Pipeline #{{id}} ({{ref}})",
  "v5.m1.pipelines.liste": "Pipelines du dépôt",
  "v5.m1.pipelines.vide": "Aucun pipeline dans le dépôt.",
  "v5.m1.publication.application": "Application",
  "v5.m1.publication.applications": "Applications du projet",
  "v5.m1.publication.aucune_application": "Aucune application générée dans ce projet.",
  "v5.m1.publication.choisir_revision": "Choisir une révision",
  "v5.m1.publication.contexte": "Application {{application}}, révision {{revision}}",
  "v5.m1.publication.lien": "Publication de la révision {{revision}}",
  "v5.m1.publication.liste": "Publications de l’application",
  "v5.m1.publication.onglet.branches": "Branches et fusions",
  "v5.m1.publication.onglet.pipelines": "Pipelines du dépôt",
  "v5.m1.publication.onglet.publications": "Publications",
  "v5.m1.publication.onglets": "Sections de la publication",
  "v5.m1.publication.publier_revision": "Publier cette révision",
  "v5.m1.publication.revision": "Révision",
  "v5.m1.publication.revision_a_choisir": "Choisissez une révision pour la publier.",
  "v5.m1.publication.statut.failed": "Échouée",
  "v5.m1.publication.statut.published": "Publiée",
  "v5.m1.publication.statut.publishing": "En cours",
  "v5.m1.publication.statut.requested": "Demandée",
  "v5.m1.publication.titre": "Publication du code",
  "v5.m1.publication.vide": "Aucune publication pour cette application.",
  "v5.m1.publier.application": "Application",
  "v5.m1.publier.autorisee": "Publication autorisée.",
  "v5.m1.publier.bloquee": "Publication bloquée : le dépôt n’est pas prêt.",
  "v5.m1.publier.confirmer": "Je confirme publier cette révision exacte vers le dépôt de l’application.",
  "v5.m1.publier.contexte_requis": "Ouvrez ce dialogue depuis une révision d’application.",
  "v5.m1.publier.controles": "Contrôles",
  "v5.m1.publier.controles_valeur": "{{passes}} / {{total}} passés",
  "v5.m1.publier.demandee": "Publication demandée.",
  "v5.m1.publier.echec": "La publication a échoué.",
  "v5.m1.publier.effet_destination": "Destination : le dépôt de l’application {{application}}.",
  "v5.m1.publier.effet_immuable": "La révision publiée est exacte et ne change plus.",
  "v5.m1.publier.effet_port": "Un environnement relié pourra exposer cette révision sur son port.",
  "v5.m1.publier.preconditions": "Préconditions du dépôt",
  "v5.m1.publier.publier": "Publier",
  "v5.m1.publier.raison_bloquee": "Publication impossible tant que le dépôt n’est pas prêt.",
  "v5.m1.publier.raison_confirmer": "Confirmez la publication pour continuer.",
  "v5.m1.publier.relecture": "Relecture",
  "v5.m1.publier.relecture_serveur": "Relecture par un tiers jugée par la passerelle à la publication",
  "v5.m1.publier.revision": "Révision",
  "v5.m1.publier.revision_inconnue": "Cette révision est introuvable dans l’application.",
  "v5.m1.publier.source": "Révision source",
  "v5.m1.publier.titre": "Publier une révision de code",
  "v5.m1.publier.verdict.approve": "Relue et approuvée",
  "v5.m1.publier.verdict.reject": "Rejetée en revue",
  "v5.m1.retour.aucune_generation": "Aucune génération terminée dans ce projet.",
  "v5.m1.retour.choisir_generation": "Choisir une génération",
  "v5.m1.retour.choisir_note": "Choisir une note",
  "v5.m1.retour.commentaire": "Commentaire (facultatif)",
  "v5.m1.retour.echec": "Le retour n’a pas été envoyé.",
  "v5.m1.retour.envoye": "Retour envoyé.",
  "v5.m1.retour.envoyer": "Envoyer le retour",
  "v5.m1.retour.evaluation": "Pris en compte par l’évaluation de {{sujet}} ({{score}} %)",
  "v5.m1.retour.generation": "Génération",
  "v5.m1.retour.generation_requise": "Choisissez la génération commentée.",
  "v5.m1.retour.generation_source": "Génération source : {{id}}",
  "v5.m1.retour.generations": "Générations du projet",
  "v5.m1.retour.libelle": "Retour",
  "v5.m1.retour.note": "Note",
  "v5.m1.retour.note_option": "{{note}} sur 5",
  "v5.m1.retour.note_requise": "Donnez une note entre 1 et 5.",
  "v5.m1.retour.note_valeur": "Note : {{note}} / 5",
  "v5.m1.retour.numero": "Retour #{{id}}",
  "v5.m1.retour.par": "Par {{auteur}}",
  "v5.m1.retour.sans_commentaire": "Sans commentaire.",
  "v5.m1.retour.sans_generation": "Génération source non identifiée.",
  "v5.m1.retour.titre_editeur": "Donner un retour sur une génération",
  "v5.m1.retour.titre_fiche": "Retour enregistré sur une génération",
  "v5.m1.retour.voir_generation": "Voir la génération",
  "v5.m1.retour_publication": "Retour à la publication du code",
  "v5.m1.sans_projet": "Choisissez un projet pour ouvrir cet écran.",
  "v5.m1.valider.attestation": "J’atteste avoir relu ce test exécutable.",
  "v5.m1.valider.attestation_requise": "Cochez l’attestation de relecture pour valider.",
  "v5.m1.valider.auteur": "Auteur du test : {{auteur}}",
  "v5.m1.valider.deja_valide": "Déjà validé par {{validateur}}",
  "v5.m1.valider.echec": "La validation a échoué.",
  "v5.m1.valider.empreinte": "Empreinte du code : {{empreinte}}",
  "v5.m1.valider.observation": "Observation (facultative)",
  "v5.m1.valider.sans_test": "Ce cas n’a pas de test exécutable à valider.",
  "v5.m1.valider.titre": "Valider un test exécutable",
  "v5.m1.valider.valide": "Test validé.",
  "v5.m1.valider.valider": "Valider le test"
}
